export const sessionUrl = '/session';
export const userUrl = '/user';
export const profileUrl = '/profile';
export const fileUrl = '/file';

export const GENERAL_INFO_STATUS = 'GENERAL INFO';
export const OCR_PROCESSING_STATUS = 'OCR PROCESSING';
export const OCR_PROCESSING_FAILED_STATUS = 'OCR PROCESSING FAILED';
export const RETRIEVAL_PROCESSING_STATUS = 'RETRIEVAL PROCESSING';
export const RETRIEVAL_PROCESSING_FAILED_STATUS = 'RETRIEVAL PROCESSING FAILED';
export const RETRIEVAL_PROCESSED_STATUS = 'RETRIEVAL PROCESSED';
export const GENERATOR_PROCESSING_STATUS = 'GENERATOR PROCESSING';
export const GENERATOR_PROCESSING_FAILED_STATUS = 'GENERATOR PROCESSING FAILED';
export const COMPLETED_STATUS = 'COMPLETED';
export const UNKNOWN_STATUS = 'Unknown';

export const statusMap = {
  [GENERAL_INFO_STATUS]: 'General Info Filled',
  [OCR_PROCESSING_STATUS]: 'Converting Documents',
  [OCR_PROCESSING_FAILED_STATUS]: 'Failed to Convert Documents',
  [RETRIEVAL_PROCESSING_STATUS]: 'Retrieving Data',
  [RETRIEVAL_PROCESSING_FAILED_STATUS]: 'Failed to Retrieve Data',
  [RETRIEVAL_PROCESSED_STATUS]: 'Data Retrieved',
  [GENERATOR_PROCESSING_STATUS]: 'Generating Demand Letter',
  [GENERATOR_PROCESSING_FAILED_STATUS]: 'Failed to Generate Demand Letter',
  [COMPLETED_STATUS]: 'Completed',
} as const;

export type StatusKey = keyof typeof statusMap;

export const STATUS_CODE_UNAUTHORIZED = 401;
export const STATUS_CODE_FORBIDDEN = 403;

export const RESEND_REQUEST_TIMEOUT = 30000;
export const OCR_RESEND_REQUEST_TIMEOUT = 1000;

export const RESEND_TIMEOUT_MAP: Partial<Record<StatusKey, number>> = {
  [OCR_PROCESSING_STATUS]: OCR_RESEND_REQUEST_TIMEOUT,
  [RETRIEVAL_PROCESSING_STATUS]: RESEND_REQUEST_TIMEOUT,
  [GENERATOR_PROCESSING_STATUS]: RESEND_REQUEST_TIMEOUT,
};

export const FILE_STATUS = {
  UPLOADED: 'uploaded',
  PENDING: 'uploading',
  FAILED: 'failed',
} as const;

type FileStatusKeys = keyof typeof FILE_STATUS;

export type FileStatus = (typeof FILE_STATUS)[FileStatusKeys];
